import { useState, useContext } from 'react';
import {
  Typography,
  Paper,
  Table,
  TableContainer,
  TableHead,
  TableBody,
} from '@mui/material';

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '../../../../../components/common/Accordion';
import {
  TableRow as StyledTableRow,
  TableCell as StyledTableCell,
} from '../../../../../components/common/Table';
import { Grid, Button, TextField } from '../../../../../components/common';
import AccordionFormContext from '../../../../../store/accordion-form-context';

export default function AdditionalIncome(props) {
  const [additionalIncomeName, setAdditionalIncomeName] = useState('');
  const [additionalIncomeAmount, setAdditionalIncomeAmount] = useState('');
  const accordionCTX = useContext(AccordionFormContext);

  const handleAddNewAdditionalIncomeSource = () => {
    accordionCTX.changeFormValue('additionalIncomeRequestList', [
      ...accordionCTX.form.additionalIncomeRequestList,
      {
        name: additionalIncomeName,
        yearlyIncome: parseFloat(additionalIncomeAmount),
      },
    ]);
    setAdditionalIncomeName('');
    setAdditionalIncomeAmount('');
  };

  const handleIncomeNameChange = (event) =>
    setAdditionalIncomeName(event.target.value);
  const handleIncomeAmountChange = (event) =>
    setAdditionalIncomeAmount(event.target.value);

  return (
    <Accordion
      square
      expanded={accordionCTX.navigation.expanded === 'panel5'}
      onChange={() => accordionCTX.changeNavigation('CHANGE', 'panel5')}
    >
      <AccordionSummary aria-controls="panel5d-content" id="panel5d-header">
        <h1>5. Dodatkowe źródła dochodu</h1>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container>
          <Grid
            infoCard
            topMargin
            item
            xs={12}
            justifyContent="center"
            alignItems="center"
            component={Paper}
          >
            <Typography variant="h4">
              Poniżej możesz dodać dodatkowe źródła dochodu jak na przykład
              dochody małżonka, renty itp.
            </Typography>
          </Grid>
          <Grid
            topMargin
            item
            xs={12}
            justifyContent="center"
            alignItems="center"
          >
            <TableContainer>
              <Table>
                <TableHead>
                  <StyledTableRow>
                    <StyledTableCell align="left">
                      Nazwa źródła dochodu
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      Roczny przychód
                    </StyledTableCell>
                    <StyledTableCell align="right" />
                  </StyledTableRow>
                </TableHead>
                <TableBody>
                  {accordionCTX.form.additionalIncomeRequestList.map(
                    (row, index) => (
                      <StyledTableRow key={index}>
                        <StyledTableCell component="th" scope="row">
                          {row.name}
                        </StyledTableCell>
                        <StyledTableCell component="th" scope="row">
                          {row.yearlyIncome} zł
                        </StyledTableCell>
                        <StyledTableCell
                          component="th"
                          scope="row"
                          align={'right'}
                        >
                          <Button
                            onClick={() => {
                              let array = [
                                ...accordionCTX.form
                                  .additionalIncomeRequestList,
                              ];
                              array.splice(index, 1);
                              accordionCTX.changeFormValue(
                                'additionalIncomeRequestList',
                                array
                              );
                            }}
                            variant="contained"
                          >
                            Usuń dochód
                          </Button>
                        </StyledTableCell>
                      </StyledTableRow>
                    )
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          <Grid
            topMargin
            container
            justifyContent="center"
            alignItems="top"
            direction={'row'}
            spacing={2}
          >
            <Grid item xs={12} md={5}>
              <TextField
                variant="outlined"
                margin="normal"
                required
                autoFocus
                fullWidth
                value={additionalIncomeName}
                id="additionalIncomeName"
                label="Podaj nazwę przychodu"
                name="additionalIncomeName"
                onChange={handleIncomeNameChange}
              />
            </Grid>
            <Grid item xs={12} md={5}>
              <TextField
                variant="outlined"
                margin="normal"
                type="number"
                value={additionalIncomeAmount}
                required
                fullWidth
                id="additionalIncomeAmount"
                label="Podaj roczny dochód w PLN"
                name="additionalIncomeAmount"
                onChange={handleIncomeAmountChange}
                error={parseInt(additionalIncomeAmount) <= 0}
                helperText={
                  parseFloat(additionalIncomeAmount) <= 0 &&
                  'Tylko wartości większe od 0'
                }
                sx={{ mt: 2 }}
              />
            </Grid>
            <Grid topMargin item xs={12} md={2}>
              <Button
                variant="contained"
                sx={{ mt: -1.5 }}
                onClick={handleAddNewAdditionalIncomeSource}
                disabled={
                  additionalIncomeName.length === 0 ||
                  additionalIncomeAmount.length === 0 ||
                  parseInt(additionalIncomeAmount) <= 0
                }
              >
                Dodaj
              </Button>
            </Grid>
          </Grid>
          <Grid topMargin container justifyContent="center" alignItems="center">
            <Button
              variant="contained"
              onClick={() => accordionCTX.changeNavigation('UNLOCK', 'panel6')}
            >
              Akceptuję dochody, chcę przejść dalej
            </Button>
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}
